import MyPhotosImport from './album-import/my-photos-import';
import CloudImport from './cloud-import';
import LocalFileImport from './local-file-import';
import MyMobileImport from './mobile-import';
import LocalFileImportIndexedDB from './local-file-import-indexeddb';
import { useGenStore } from 'stores/useGenStore';

const computeSources = (isSafariPrivate) => {
  return [
    {
      title: 'My Mobile',
      component: MyMobileImport,
      service: 'mobile',
    },
    {
      title: 'My Computer',
      component: window.prismItem
        ? window.featureFlags.indexed_db_uploader && !isSafariPrivate
          ? LocalFileImportIndexedDB
          : LocalFileImport
        : LocalFileImport,
      service: 'upload',
    },
    {
      title: 'My Photos',
      component: MyPhotosImport,
      service: 'albums',
    },
    {
      title: 'Google',
      component: CloudImport,
      service: 'picasa',
    },
    {
      title: 'Facebook',
      component: CloudImport,
      service: 'facebook',
    },
    {
      title: 'Dropbox',
      component: CloudImport,
      service: 'dropbox',
    },
    {
      title: 'Instagram',
      component: CloudImport,
      service: 'instagram',
    },
    {
      title: 'Flickr',
      component: CloudImport,
      service: 'flickr',
    },
  ].filter(({ service }) =>
    service === 'mobile' ? MyMobileImport.isActive() : true,
  );
};

const getImageSources = () => {
  const isSafariPrivate = useGenStore.getState().isSafariPrivate;

  const imageSources = computeSources(isSafariPrivate);

  return imageSources;
};

export default getImageSources;
